<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                excelImportForm: () => import('../forms/ExcelImportForm'),
                fields: [
                    { type: 'autocomplete', text: 'Excel Import', value: 'excelImportId', rules: [v => !!v || 'Excel Import is required'], isRequired: true, form: () => import('./ExcelImportForm'), apiMethod: 'ExcelImports', claim: 'ExcelImports' },
                    { type: 'number', text: 'Row', value: 'row', rules: [] },
                    { type: 'textarea', text: 'Description', value: 'description', rules: [v => !!v || 'Description is required'], isRequired: true, maxLength: false },
                ],
                apiMethod: 'ExcelImportErrors',
                formTitle: 'Excel Import Error',
            }
        },
    };
</script>
